import React from "react";


const EPagentconfigure = () => {
  document.title = "ep-agent-configure";

  return (
    <React.Fragment>
      <div className="page-content">

        <h1>ep-agent-configure</h1>
        
      </div>
    </React.Fragment>
  );
};

export default EPagentconfigure;
